export const NavItems = [
  {
    name: "Overview",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.66699 5.4165C1.66699 3.64874 1.66699 2.76485 2.21617 2.21568C2.76534 1.6665 3.64923 1.6665 5.41699 1.6665C7.18476 1.6665 8.06864 1.6665 8.61783 2.21568C9.16699 2.76485 9.16699 3.64874 9.16699 5.4165C9.16699 7.18427 9.16699 8.06815 8.61783 8.61734C8.06864 9.1665 7.18476 9.1665 5.41699 9.1665C3.64923 9.1665 2.76534 9.1665 2.21617 8.61734C1.66699 8.06815 1.66699 7.18427 1.66699 5.4165Z"
          fill="white"
        />
        <path
          d="M10.833 14.5835C10.833 12.8157 10.833 11.9318 11.3822 11.3827C11.9313 10.8335 12.8153 10.8335 14.583 10.8335C16.3508 10.8335 17.2347 10.8335 17.7838 11.3827C18.333 11.9318 18.333 12.8157 18.333 14.5835C18.333 16.3512 18.333 17.2352 17.7838 17.7843C17.2347 18.3335 16.3508 18.3335 14.583 18.3335C12.8153 18.3335 11.9313 18.3335 11.3822 17.7843C10.833 17.2352 10.833 16.3512 10.833 14.5835Z"
          fill="white"
        />
        <path
          d="M1.66699 14.5835C1.66699 12.8157 1.66699 11.9318 2.21617 11.3827C2.76534 10.8335 3.64923 10.8335 5.41699 10.8335C7.18476 10.8335 8.06864 10.8335 8.61783 11.3827C9.16699 11.9318 9.16699 12.8157 9.16699 14.5835C9.16699 16.3512 9.16699 17.2352 8.61783 17.7843C8.06864 18.3335 7.18476 18.3335 5.41699 18.3335C3.64923 18.3335 2.76534 18.3335 2.21617 17.7843C1.66699 17.2352 1.66699 16.3512 1.66699 14.5835Z"
          fill="white"
        />
        <path
          d="M10.833 5.4165C10.833 3.64874 10.833 2.76485 11.3822 2.21568C11.9313 1.6665 12.8153 1.6665 14.583 1.6665C16.3508 1.6665 17.2347 1.6665 17.7838 2.21568C18.333 2.76485 18.333 3.64874 18.333 5.4165C18.333 7.18427 18.333 8.06815 17.7838 8.61734C17.2347 9.1665 16.3508 9.1665 14.583 9.1665C12.8153 9.1665 11.9313 9.1665 11.3822 8.61734C10.833 8.06815 10.833 7.18427 10.833 5.4165Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M2.08334 5.41667C2.08334 3.84532 2.08334 3.05964 2.5715 2.57149C3.05965 2.08334 3.84533 2.08334 5.41668 2.08334C6.98803 2.08334 7.7737 2.08334 8.26185 2.57149C8.75001 3.05964 8.75001 3.84532 8.75001 5.41667C8.75001 6.98802 8.75001 7.77369 8.26185 8.26184C7.7737 8.75 6.98803 8.75 5.41668 8.75C3.84533 8.75 3.05965 8.75 2.5715 8.26184C2.08334 7.77369 2.08334 6.98802 2.08334 5.41667Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M11.25 14.5833C11.25 13.012 11.25 12.2263 11.7382 11.7382C12.2263 11.25 13.012 11.25 14.5833 11.25C16.1547 11.25 16.9403 11.25 17.4285 11.7382C17.9167 12.2263 17.9167 13.012 17.9167 14.5833C17.9167 16.1547 17.9167 16.9403 17.4285 17.4285C16.9403 17.9167 16.1547 17.9167 14.5833 17.9167C13.012 17.9167 12.2263 17.9167 11.7382 17.4285C11.25 16.9403 11.25 16.1547 11.25 14.5833Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M2.08334 14.5833C2.08334 13.012 2.08334 12.2263 2.5715 11.7382C3.05965 11.25 3.84533 11.25 5.41668 11.25C6.98803 11.25 7.7737 11.25 8.26185 11.7382C8.75001 12.2263 8.75001 13.012 8.75001 14.5833C8.75001 16.1547 8.75001 16.9403 8.26185 17.4285C7.7737 17.9167 6.98803 17.9167 5.41668 17.9167C3.84533 17.9167 3.05965 17.9167 2.5715 17.4285C2.08334 16.9403 2.08334 16.1547 2.08334 14.5833Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M11.25 5.41667C11.25 3.84532 11.25 3.05964 11.7382 2.57149C12.2263 2.08334 13.012 2.08334 14.5833 2.08334C16.1547 2.08334 16.9403 2.08334 17.4285 2.57149C17.9167 3.05964 17.9167 3.84532 17.9167 5.41667C17.9167 6.98802 17.9167 7.77369 17.4285 8.26184C16.9403 8.75 16.1547 8.75 14.5833 8.75C13.012 8.75 12.2263 8.75 11.7382 8.26184C11.25 7.77369 11.25 6.98802 11.25 5.41667Z"
          stroke="#909090"
          stroke-width="1.5"
        />
      </svg>
    ),
    link: "/overview"
  },
  {
    name: "Insights",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.6667 11.4583C16.6667 11.1132 16.3868 10.8333 16.0417 10.8333H13.5417C13.1965 10.8333 12.9167 11.1132 12.9167 11.4583V17.0833H11.6667V3.54167C11.6667 2.93475 11.6653 2.54243 11.6265 2.25336C11.59 1.98227 11.5312 1.89731 11.4836 1.84973C11.436 1.80216 11.3511 1.74331 11.08 1.70686C10.7909 1.668 10.3986 1.66667 9.79167 1.66667C9.18475 1.66667 8.79242 1.668 8.50333 1.70686C8.23227 1.74331 8.1473 1.80216 8.09972 1.84973C8.05215 1.89731 7.9933 1.98227 7.95686 2.25336C7.91799 2.54243 7.91667 2.93475 7.91667 3.54167V17.0833H6.66667V7.29167C6.66667 6.9465 6.38684 6.66667 6.04167 6.66667H3.54167C3.19649 6.66667 2.91667 6.9465 2.91667 7.29167L2.91667 17.0833H1.66667H1.45833C1.11316 17.0833 0.833332 17.3632 0.833332 17.7083C0.833332 18.0535 1.11316 18.3333 1.45833 18.3333H18.125C18.4702 18.3333 18.75 18.0535 18.75 17.7083C18.75 17.3632 18.4702 17.0833 18.125 17.0833H17.9167H16.6667V11.4583Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M18.3337 18.3335L1.66699 18.3335"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M17.5 18.3335V12.0835C17.5 11.3932 16.9403 10.8335 16.25 10.8335H13.75C13.0597 10.8335 12.5 11.3932 12.5 12.0835V18.3335"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M12.5 18.3332L12.5 4.1665C12.5 2.988 12.5 2.39874 12.1339 2.03262C11.7678 1.6665 11.1785 1.6665 10 1.6665C8.8215 1.6665 8.23223 1.6665 7.86612 2.03262C7.5 2.39874 7.5 2.988 7.5 4.1665L7.5 18.3332"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M7.5 18.3332L7.5 7.9165C7.5 7.22615 6.94036 6.6665 6.25 6.6665H3.75C3.05964 6.6665 2.5 7.22615 2.5 7.9165L2.5 18.3332"
          stroke="#909090"
          stroke-width="1.5"
        />
      </svg>
    ),
    link: "/insights"
  },
  {
    name: "Splits",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.5 5C7.5 6.38071 8.61925 7.5 10 7.5C11.3807 7.5 12.5 6.38071 12.5 5C12.5 3.61929 11.3807 2.5 10 2.5C8.61925 2.5 7.5 3.61929 7.5 5Z"
          fill="white"
        />
        <path
          d="M2.08334 15C2.08334 16.3807 3.20264 17.5 4.58334 17.5C5.96405 17.5 7.08334 16.3807 7.08334 15C7.08334 13.6192 5.96405 12.5 4.58334 12.5C3.20264 12.5 2.08334 13.6192 2.08334 15Z"
          fill="white"
        />
        <path
          d="M15.4167 17.5C14.0359 17.5 12.9167 16.3807 12.9167 15C12.9167 13.6192 14.0359 12.5 15.4167 12.5C16.7974 12.5 17.9167 13.6192 17.9167 15C17.9167 16.3807 16.7974 17.5 15.4167 17.5Z"
          fill="white"
        />
        <path
          d="M6.00391 6.30191C6.2627 6.07349 6.28733 5.67854 6.05892 5.41974C5.8305 5.16094 5.43554 5.13632 5.17674 5.36473C3.66398 6.69991 2.70834 8.6554 2.70834 10.8333C2.70834 11.1785 2.98817 11.4583 3.33334 11.4583C3.67852 11.4583 3.95834 11.1785 3.95834 10.8333C3.95834 9.0289 4.74858 7.40988 6.00391 6.30191Z"
          fill="white"
        />
        <path
          d="M14.8232 5.36473C14.5645 5.13632 14.1695 5.16094 13.9411 5.41974C13.7127 5.67854 13.7373 6.07349 13.9961 6.30191C15.2514 7.40988 16.0417 9.0289 16.0417 10.8333C16.0417 11.1785 16.3215 11.4583 16.6667 11.4583C17.0118 11.4583 17.2917 11.1785 17.2917 10.8333C17.2917 8.6554 16.336 6.69991 14.8232 5.36473Z"
          fill="white"
        />
        <path
          d="M8.48909 16.6848C8.15484 16.5987 7.81411 16.7999 7.72807 17.1342C7.64203 17.4685 7.84327 17.8093 8.17756 17.8953C8.76076 18.0453 9.37151 18.125 10 18.125C10.6285 18.125 11.2393 18.0453 11.8224 17.8953C12.1568 17.8093 12.358 17.4685 12.2719 17.1342C12.1859 16.7999 11.8452 16.5987 11.5109 16.6848C11.0287 16.8088 10.5225 16.875 10 16.875C9.47751 16.875 8.97134 16.8088 8.48909 16.6848Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 7.5C8.61925 7.5 7.5 6.38071 7.5 5C7.5 3.61929 8.61925 2.5 10 2.5C11.3807 2.5 12.5 3.61929 12.5 5C12.5 6.38071 11.3807 7.5 10 7.5Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M4.58301 17.5C3.2023 17.5 2.08301 16.3807 2.08301 15C2.08301 13.6192 3.2023 12.5 4.58301 12.5C5.96372 12.5 7.08301 13.6192 7.08301 15C7.08301 16.3807 5.96372 17.5 4.58301 17.5Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M15.417 17.5C14.0362 17.5 12.917 16.3807 12.917 15C12.917 13.6192 14.0362 12.5 15.417 12.5C16.7977 12.5 17.917 13.6192 17.917 15C17.917 16.3807 16.7977 17.5 15.417 17.5Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M16.6663 10.8335C16.6663 8.84233 15.7934 7.05507 14.4093 5.8335M3.33301 10.8335C3.33301 8.84233 4.20594 7.05507 5.58999 5.8335M8.33301 17.2902C8.86567 17.4272 9.42417 17.5002 9.99967 17.5002C10.5752 17.5002 11.1337 17.4272 11.6663 17.2902"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    link: "/splits"
  },
  {
    name: "Artists",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 1.66666C7.35364 1.66666 5.20834 3.81196 5.20834 6.45833V8.95833C5.20834 11.6047 7.35364 13.75 10 13.75C12.4345 13.75 14.445 11.9344 14.7513 9.58333H10.8333C10.4882 9.58333 10.2083 9.3035 10.2083 8.95833C10.2083 8.61316 10.4882 8.33333 10.8333 8.33333H14.7917V7.08333H10.8333C10.4882 7.08333 10.2083 6.80351 10.2083 6.45833C10.2083 6.11316 10.4882 5.83333 10.8333 5.83333H14.7513C14.445 3.48227 12.4345 1.66666 10 1.66666Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.33334 7.5C3.67852 7.5 3.95834 7.77983 3.95834 8.125V8.95833C3.95834 12.2951 6.66329 15 10 15C13.3368 15 16.0417 12.2951 16.0417 8.95833V8.125C16.0417 7.77983 16.3215 7.5 16.6667 7.5C17.0118 7.5 17.2917 7.77983 17.2917 8.125V8.95833C17.2917 12.7748 14.3595 15.9066 10.625 16.2236V18.125C10.625 18.4702 10.3452 18.75 10 18.75C9.65484 18.75 9.37501 18.4702 9.37501 18.125V16.2236C5.64051 15.9066 2.70834 12.7748 2.70834 8.95833V8.125C2.70834 7.77983 2.98817 7.5 3.33334 7.5Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M5.83301 6.66667C5.83301 4.36548 7.69849 2.5 9.99967 2.5C12.3008 2.5 14.1663 4.36548 14.1663 6.66667V9.16667C14.1663 11.4678 12.3008 13.3333 9.99967 13.3333C7.69849 13.3333 5.83301 11.4678 5.83301 9.16667V6.66667Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M10.833 6.6665H14.1663"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M10.833 9.1665H14.1663"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M16.6663 8.3335V9.16683C16.6663 12.8487 13.6816 15.8335 9.99967 15.8335C6.31777 15.8335 3.33301 12.8487 3.33301 9.16683V8.3335"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M10 15.8335V18.3335"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    link: "/artists"
  },
  {
    name: "Upgrade",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.1124 2.88706C15.892 1.66666 13.9278 1.66666 9.99944 1.66666C6.07106 1.66666 4.10688 1.66666 2.8865 2.88706C2.25526 3.51829 1.95052 4.34853 1.80341 5.54665C2.24563 5.05443 2.77699 4.6444 3.37366 4.34038C4.02489 4.00856 4.72222 3.874 5.49432 3.81091C6.24026 3.74997 7.15811 3.74998 8.28041 3.75H11.7184C12.8408 3.74998 13.7586 3.74997 14.5045 3.81091C15.2767 3.874 15.974 4.00856 16.6252 4.34038C17.2219 4.6444 17.7533 5.05443 18.1954 5.54665C18.0484 4.34853 17.7436 3.51829 17.1124 2.88706Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.66669 11.6667C1.66669 9.33308 1.66669 8.16634 2.12083 7.27504C2.5203 6.49103 3.15772 5.85361 3.94173 5.45414C4.83303 5 5.9998 5 8.33335 5H11.6667C14.0003 5 15.167 5 16.0584 5.45414C16.8424 5.85361 17.4798 6.49103 17.8792 7.27504C18.3334 8.16634 18.3334 9.33308 18.3334 11.6667C18.3334 14.0002 18.3334 15.167 17.8792 16.0583C17.4798 16.8423 16.8424 17.4797 16.0584 17.8792C15.167 18.3333 14.0003 18.3333 11.6667 18.3333H8.33335C5.9998 18.3333 4.83303 18.3333 3.94173 17.8792C3.15772 17.4797 2.5203 16.8423 2.12083 16.0583C1.66669 15.167 1.66669 14.0002 1.66669 11.6667ZM10.4419 8.72475C10.3248 8.6075 10.1658 8.54167 10 8.54167C9.83427 8.54167 9.67527 8.6075 9.5581 8.72475L7.47475 10.8081C7.23067 11.0522 7.23067 11.4478 7.47475 11.6919C7.71882 11.936 8.11455 11.936 8.3586 11.6919L9.37502 10.6756V14.1667C9.37502 14.5118 9.65485 14.7917 10 14.7917C10.3452 14.7917 10.625 14.5118 10.625 14.1667V10.6756L11.6414 11.6919C11.8855 11.936 12.2812 11.936 12.5253 11.6919C12.7694 11.4478 12.7694 11.0522 12.5253 10.8081L10.4419 8.72475Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.66699 9.99984C1.66699 6.07146 1.66699 4.10728 2.88738 2.8869C4.10777 1.6665 6.07195 1.6665 10.0003 1.6665C13.9287 1.6665 15.8929 1.6665 17.1132 2.8869C18.3337 4.10728 18.3337 6.07146 18.3337 9.99984"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M1.66699 11.6667C1.66699 9.33308 1.66699 8.16634 2.12113 7.27504C2.5206 6.49103 3.15803 5.85361 3.94203 5.45414C4.83333 5 6.00011 5 8.33366 5H11.667C14.0006 5 15.1673 5 16.0587 5.45414C16.8427 5.85361 17.4801 6.49103 17.8795 7.27504C18.3337 8.16634 18.3337 9.33308 18.3337 11.6667C18.3337 14.0002 18.3337 15.167 17.8795 16.0583C17.4801 16.8423 16.8427 17.4797 16.0587 17.8792C15.1673 18.3333 14.0006 18.3333 11.667 18.3333H8.33366C6.00011 18.3333 4.83333 18.3333 3.94203 17.8792C3.15803 17.4797 2.5206 16.8423 2.12113 16.0583C1.66699 15.167 1.66699 14.0002 1.66699 11.6667Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M10.0003 14.1665V9.1665M10.0003 9.1665L12.0837 11.2498M10.0003 9.1665L7.91699 11.2498"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    link: "/upgrade"
  },
  {
    name: "Promotion",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.79163 11.6667C4.79163 10.6312 5.63109 9.79167 6.66663 9.79167C7.70216 9.79167 8.54163 10.6312 8.54163 11.6667C8.54163 12.7022 7.70216 13.5417 6.66663 13.5417C5.63109 13.5417 4.79163 12.7022 4.79163 11.6667Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.7662 3.06566C13.0785 2.91869 13.2126 2.54635 13.0656 2.23403C12.9186 1.9217 12.5463 1.78766 12.234 1.93464L5.63906 5.03813C4.19285 5.11239 3.28801 5.33124 2.64293 5.97631C1.66663 6.95263 1.66663 8.524 1.66663 11.6667C1.66663 14.8093 1.66663 16.3808 2.64293 17.357C3.61925 18.3333 5.19059 18.3333 8.33329 18.3333H11.6666C14.8093 18.3333 16.3807 18.3333 17.357 17.357C18.3333 16.3808 18.3333 14.8093 18.3333 11.6667C18.3333 8.524 18.3333 6.95262 17.357 5.97631C16.3807 5 14.8093 5 11.6666 5H8.65579L12.7662 3.06566ZM6.66663 8.54167C4.94073 8.54167 3.54163 9.94075 3.54163 11.6667C3.54163 13.3926 4.94073 14.7917 6.66663 14.7917C8.39254 14.7917 9.79163 13.3926 9.79163 11.6667C9.79163 9.94075 8.39254 8.54167 6.66663 8.54167ZM10.625 9.16667C10.625 8.8215 10.9048 8.54167 11.25 8.54167H15.8333C16.1785 8.54167 16.4583 8.8215 16.4583 9.16667C16.4583 9.51184 16.1785 9.79167 15.8333 9.79167H11.25C10.9048 9.79167 10.625 9.51184 10.625 9.16667ZM11.25 11.0417C10.9048 11.0417 10.625 11.3215 10.625 11.6667C10.625 12.0118 10.9048 12.2917 11.25 12.2917H15.8333C16.1785 12.2917 16.4583 12.0118 16.4583 11.6667C16.4583 11.3215 16.1785 11.0417 15.8333 11.0417H11.25ZM10.625 14.1667C10.625 13.8215 10.9048 13.5417 11.25 13.5417H15.8333C16.1785 13.5417 16.4583 13.8215 16.4583 14.1667C16.4583 14.5118 16.1785 14.7917 15.8333 14.7917H11.25C10.9048 14.7917 10.625 14.5118 10.625 14.1667Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M1.66699 11.6667C1.66699 8.524 1.66699 6.95262 2.6433 5.97631C3.61962 5 5.19096 5 8.33366 5H11.667C14.8097 5 16.3811 5 17.3573 5.97631C18.3337 6.95262 18.3337 8.524 18.3337 11.6667C18.3337 14.8093 18.3337 16.3807 17.3573 17.357C16.3811 18.3333 14.8097 18.3333 11.667 18.3333H8.33366C5.19096 18.3333 3.61962 18.3333 2.6433 17.357C1.66699 16.3807 1.66699 14.8093 1.66699 11.6667Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M6.66699 14.1665C8.0477 14.1665 9.16699 13.0472 9.16699 11.6665C9.16699 10.2858 8.0477 9.1665 6.66699 9.1665C5.28628 9.1665 4.16699 10.2858 4.16699 11.6665C4.16699 13.0472 5.28628 14.1665 6.66699 14.1665Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M11.25 9.1665H15.8333"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M11.25 11.6665H15.8333"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M11.25 14.1665H15.8333"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M5.41699 4.99984L12.5003 1.6665"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    link: "/promotion"
  },
  {
    name: "Bank",
    activeIcon: "",
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M7.50033 15.8332C5.15956 15.8332 3.98917 15.8332 3.14843 15.2714C2.78446 15.0282 2.47196 14.7157 2.22876 14.3518C1.66699 13.511 1.66699 12.3406 1.66699 9.99984C1.66699 7.65907 1.66699 6.48868 2.22876 5.64794C2.47196 5.28397 2.78446 4.97147 3.14843 4.72827C3.98917 4.1665 5.15956 4.1665 7.50033 4.1665H12.5003C14.8411 4.1665 16.0115 4.1665 16.8522 4.72827C17.2162 4.97147 17.5287 5.28397 17.7719 5.64794C18.3337 6.48868 18.3337 7.65907 18.3337 9.99984C18.3337 12.3406 18.3337 13.511 17.7719 14.3518C17.5287 14.7157 17.2162 15.0282 16.8522 15.2714C16.0115 15.8332 14.8411 15.8332 12.5003 15.8332L7.50033 15.8332Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M10 7.5C11.3807 7.5 12.5 8.61925 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61925 12.5 7.5 11.3807 7.5 10C7.5 8.61925 8.61925 7.5 10 7.5Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M4.58301 12.5L4.58301 7.5"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M15.417 12.5V7.5"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    link: "/bank"
  }
];

export const AccountItems = [
  {
    name: "Customer Support",
    activeIcon: "",
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.5 14.1667V10C17.5 5.85787 14.1422 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10L2.5 14.1667"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M18.333 12.9165V14.5832"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M1.66699 12.9165L1.66699 14.5832"
          stroke="#909090"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M6.66667 11.5372C6.66667 10.9002 6.66667 10.5817 6.52105 10.3602C6.44778 10.2487 6.35051 10.1567 6.237 10.0912C6.01142 9.96125 5.70677 9.99133 5.09745 10.0514C4.07073 10.1526 3.55737 10.2032 3.18947 10.4803C3.00328 10.6207 2.84698 10.7994 2.73038 11.0056C2.5 11.4129 2.5 11.9496 2.5 13.023V14.3277C2.5 15.3904 2.5 15.9217 2.73498 16.3322C2.82293 16.4857 2.93317 16.6242 3.0618 16.7427C3.40543 17.0595 3.90703 17.1584 4.91023 17.3562C5.6162 17.4954 5.96918 17.565 6.2297 17.4184C6.32583 17.3643 6.4108 17.2911 6.47977 17.2028C6.66667 16.9637 6.66667 16.5898 6.66667 15.842L6.66667 11.5372Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M13.333 11.5372C13.333 10.9002 13.333 10.5817 13.4786 10.3602C13.5519 10.2487 13.6492 10.1567 13.7627 10.0912C13.9883 9.96125 14.2929 9.99133 14.9023 10.0514C15.9289 10.1526 16.4423 10.2032 16.8102 10.4803C16.9964 10.6207 17.1527 10.7994 17.2693 11.0056C17.4997 11.4129 17.4997 11.9496 17.4997 13.023V14.3277C17.4997 15.3904 17.4997 15.9217 17.2647 16.3322C17.1768 16.4857 17.0665 16.6242 16.9378 16.7427C16.5943 17.0595 16.0927 17.1584 15.0894 17.3562C14.3835 17.4954 14.0305 17.565 13.77 17.4184C13.6738 17.3643 13.5888 17.2911 13.5199 17.2028C13.333 16.9637 13.333 16.5898 13.333 15.842V11.5372Z"
          stroke="#909090"
          stroke-width="1.5"
        />
      </svg>
    ),
    link: "/customer-support"
  },
  {
    name: "Settings",
    activeIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.899 1.79352C11.5904 1.66666 11.1992 1.66666 10.4167 1.66666C9.63416 1.66666 9.24291 1.66666 8.93433 1.79352C8.52283 1.96268 8.19591 2.28714 8.02546 2.69551C7.94766 2.88194 7.91721 3.09874 7.90529 3.41498C7.88778 3.87972 7.64763 4.3099 7.24181 4.54243C6.83598 4.77496 6.34053 4.76627 5.92624 4.54896C5.64431 4.40107 5.43991 4.31884 5.23832 4.29251C4.79674 4.23481 4.35015 4.35356 3.9968 4.62266C3.73178 4.82447 3.53616 5.16074 3.14491 5.83326C2.75367 6.5058 2.55806 6.84206 2.51446 7.17075C2.45631 7.60899 2.57598 8.05221 2.84712 8.40291C2.97088 8.56299 3.14481 8.69749 3.41475 8.86582C3.81159 9.11332 4.06693 9.53491 4.06691 9.99999C4.06688 10.4651 3.81155 10.8866 3.41475 11.134C3.14476 11.3024 2.97081 11.437 2.84704 11.5971C2.5759 11.9477 2.45624 12.3909 2.51437 12.8292C2.55797 13.1578 2.7536 13.4942 3.14483 14.1667C3.53607 14.8392 3.7317 15.1755 3.99671 15.3772C4.35006 15.6463 4.79666 15.7651 5.23824 15.7074C5.43981 15.6811 5.64421 15.5988 5.92611 15.451C6.34043 15.2337 6.83591 15.225 7.24176 15.4575C7.64761 15.6901 7.88777 16.1202 7.90529 16.5851C7.91721 16.9012 7.94766 17.1181 8.02546 17.3045C8.19591 17.7128 8.52283 18.0373 8.93433 18.2065C9.24291 18.3333 9.63416 18.3333 10.4167 18.3333C11.1992 18.3333 11.5904 18.3333 11.899 18.2065C12.3105 18.0373 12.6374 17.7128 12.8078 17.3045C12.8857 17.1181 12.9162 16.9012 12.9281 16.585C12.9456 16.1202 13.1857 15.6901 13.5915 15.4575C13.9973 15.2249 14.4928 15.2337 14.9072 15.451C15.1891 15.5988 15.3934 15.681 15.595 15.7073C16.0366 15.7651 16.4832 15.6463 16.8365 15.3772C17.1016 15.1754 17.2972 14.8392 17.6884 14.1666C18.0797 13.4941 18.2752 13.1578 18.3189 12.8292C18.377 12.3909 18.2573 11.9477 17.9862 11.597C17.8624 11.4369 17.6885 11.3023 17.4185 11.134C17.0217 10.8866 16.7664 10.465 16.7664 9.99991C16.7664 9.53482 17.0217 9.11341 17.4185 8.86599C17.6886 8.69757 17.8625 8.56307 17.9863 8.40291C18.2574 8.05226 18.3771 7.60905 18.319 7.1708C18.2753 6.84211 18.0797 6.50585 17.6885 5.83332C17.2972 5.1608 17.1017 4.82453 16.8366 4.62271C16.4832 4.35362 16.0367 4.23486 15.5951 4.29256C15.3935 4.3189 15.1891 4.40112 14.9072 4.54899C14.4929 4.76631 13.9974 4.77501 13.5916 4.54246C13.1857 4.30991 12.9456 3.87971 12.928 3.41494C12.9161 3.09872 12.8857 2.88193 12.8078 2.69551C12.6374 2.28714 12.3105 1.96268 11.899 1.79352ZM10.4167 12.5C11.8079 12.5 12.9357 11.3807 12.9357 9.99999C12.9357 8.61924 11.8079 7.49999 10.4167 7.49999C9.02541 7.49999 7.89763 8.61924 7.89763 9.99999C7.89763 11.3807 9.02541 12.5 10.4167 12.5Z"
          fill="white"
        />
      </svg>
    ),
    inactiveIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
          stroke="#909090"
          stroke-width="1.5"
        />
        <path
          d="M11.4716 1.79337C11.1652 1.6665 10.777 1.6665 10.0004 1.6665C9.22382 1.6665 8.83557 1.6665 8.52924 1.79337C8.12088 1.96253 7.79642 2.28699 7.62726 2.69536C7.55005 2.88179 7.51982 3.09859 7.508 3.41483C7.49062 3.87957 7.25229 4.30975 6.84952 4.54228C6.44677 4.7748 5.95506 4.76612 5.5439 4.5488C5.26411 4.40092 5.06125 4.31869 4.86119 4.29235C4.42294 4.23465 3.97972 4.35341 3.62904 4.6225C3.36602 4.82432 3.17188 5.16059 2.7836 5.83311C2.39531 6.50565 2.20117 6.8419 2.1579 7.1706C2.1002 7.60884 2.21896 8.05205 2.48805 8.40275C2.61087 8.56284 2.78349 8.69734 3.0514 8.86567C3.44524 9.11317 3.69865 9.53475 3.69862 9.99984C3.6986 10.4649 3.4452 10.8864 3.05139 11.1338C2.78345 11.3023 2.6108 11.4368 2.48797 11.5969C2.21888 11.9476 2.10012 12.3908 2.15782 12.829C2.20109 13.1577 2.39523 13.494 2.78351 14.1665C3.1718 14.839 3.36595 15.1753 3.62895 15.3771C3.97964 15.6462 4.42285 15.7649 4.8611 15.7073C5.06115 15.6809 5.264 15.5987 5.54377 15.4508C5.95496 15.2335 6.4467 15.2248 6.84949 15.4573C7.25227 15.6899 7.49062 16.1201 7.508 16.5849C7.51983 16.9011 7.55005 17.1179 7.62726 17.3043C7.79642 17.7127 8.12088 18.0372 8.52924 18.2063C8.83557 18.3332 9.22382 18.3332 10.0004 18.3332C10.777 18.3332 11.1652 18.3332 11.4716 18.2063C11.8799 18.0372 12.2044 17.7127 12.3735 17.3043C12.4507 17.1179 12.481 16.9011 12.4928 16.5848C12.5102 16.1201 12.7485 15.6899 13.1512 15.4573C13.554 15.2248 14.0457 15.2335 14.457 15.4508C14.7367 15.5987 14.9396 15.6808 15.1396 15.7072C15.5778 15.7649 16.0211 15.6462 16.3717 15.3771C16.6347 15.1753 16.8289 14.839 17.2172 14.1664C17.6055 13.4939 17.7997 13.1577 17.8429 12.829C17.9006 12.3908 17.7818 11.9475 17.5127 11.5968C17.3899 11.4368 17.2172 11.3022 16.9493 11.1338C16.5556 10.8864 16.3022 10.4648 16.3022 9.99975C16.3022 9.53467 16.5556 9.11325 16.9493 8.86584C17.2173 8.69742 17.39 8.56292 17.5128 8.40275C17.7819 8.05211 17.9007 7.6089 17.843 7.17065C17.7997 6.84196 17.6056 6.5057 17.2172 5.83317C16.829 5.16065 16.6348 4.82438 16.3718 4.62256C16.0212 4.35347 15.5779 4.23471 15.1397 4.29241C14.9397 4.31875 14.7368 4.40097 14.457 4.54884C14.0458 4.76616 13.5541 4.77485 13.1513 4.5423C12.7485 4.30976 12.5102 3.87955 12.4928 3.41479C12.481 3.09857 12.4507 2.88178 12.3735 2.69536C12.2044 2.28699 11.8799 1.96253 11.4716 1.79337Z"
          stroke="#909090"
          stroke-width="1.5"
        />
      </svg>
    ),
    link: "/settings"
  }
];
